// Centralized Sentry event names. Sentry alert rules, dashboards, and triage
// queries reference these strings exactly — typos at the call site silently
// break observability, so every captureMessage in the auth/login flow MUST
// reference a constant from here instead of a raw string.
export const SENTRY_EVENTS = {
  BROWSER_OPEN_HUNG: "LoginPage.browser_open_hung",
  AUTH_LOOP_DETECTED: "LoginPage.auth_loop_detected",
  RELAUNCH_LOOP_DETECTED: "LoginPage.relaunch_loop_detected",
  AUTH_CALLBACK_MISSING_PARAMS: "LoginPage.auth_callback_missing_params",
  CODE_EXCHANGE_FAILED_RESETTING_TO_AUTH: "code_exchange_failed_resetting_to_auth",
  GET_USER_PROFILE_NO_ACCESS: "getUserProfile_no_access",
  GET_USER_PROFILE_FAILED_AFTER_RETRIES: "getUserProfile_failed_after_retries",

  TOKEN_REQUEST_NON_2XX: "authFlow.token_request_non_2xx",
  CODE_EXCHANGE_NON_2XX: "authFlow.code_exchange_non_2xx",
  CODE_EXCHANGE_INVALID_BODY: "authFlow.code_exchange_invalid_body",
  USER_PROFILE_4XX: "authFlow.user_profile_4xx",
  USER_PROFILE_INVALID_BODY: "authFlow.user_profile_invalid_body",
  VALIDATE_ROLES_4XX: "authFlow.validate_roles_4xx",
  VALIDATE_ROLES_NO_ACCESS: "authFlow.validate_roles_no_access",
} as const;

export const authFlowSlowEvent = (endpoint: string) =>
  `authFlow.${endpoint}_slow`;
